import client from 'api'
import { fromFilterToDates } from 'helpers/from-filter-to-dates'

export const getJobsData = async (dateFilter: any) => {
    const fromFilter = fromFilterToDates(dateFilter)
    const url = fromFilter
        ? `/api/ixweb/jobs/status/?MIN_HDR_H1_TIMESTAMP=${fromFilter.from}&MAX_HDR_H1_TIMESTAMP=${fromFilter.to}`
        : '/api/ixweb/jobs/status/'

    return await client.get(url)
}
